module.exports = __webpack_public_path__ + "static/media/Family - Hexagon 1.e095d7a9.png";